import { CommonModule } from '@angular/common';
import * as i0 from '@angular/core';
import { NgModule, Injectable, Inject } from '@angular/core';
import * as i2 from '@upr-web-primer/locale';
import { LocaleModule } from '@upr-web-primer/locale';
import { WindowModule, WINDOW } from '@upr-web-primer/window';
import * as i1 from '@angular/router';
import { get, compact } from 'lodash-es';
import { BehaviorSubject } from 'rxjs';
class UrlInfoModule {
  static {
    this.ɵfac = function UrlInfoModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || UrlInfoModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: UrlInfoModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule, WindowModule, LocaleModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(UrlInfoModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule, WindowModule, LocaleModule]
    }]
  }], null, null);
})();
class UrlInfoService {
  constructor(route, localeService, window, TridionSite, appDefaults) {
    this.route = route;
    this.localeService = localeService;
    this.window = window;
    this.TridionSite = TridionSite;
    this.appDefaults = appDefaults;
    const locale = this.localeService.getFromStorage();
    const snapUrlRaw = get(this.route, 'snapshot.url', []);
    const snapUrl = Array.isArray(snapUrlRaw) ? snapUrlRaw : [];
    this.info$ = new BehaviorSubject({
      path: snapUrl.length ? snapUrl.join('/') : this.window.location.pathname,
      publication: get(this.route, 'snapshot.params.publication', ''),
      language: locale.language,
      country: locale.country,
      slug: get(this.route, 'snapshot.data.slug', '')
    });
  }
  setUrlInfo(urlInfo) {
    this.urlInfo = urlInfo;
    this.info$.next(this.urlInfo);
  }
  get(route) {
    const locale = this.localeService.getFromStorage();
    const tridionPublication = this.TridionSite || 'k2';
    const sub_directory = get(this.appDefaults, 'TRIDION_APP_DIRECTORY', '');
    let country = get(route.url, '1.path', locale.country);
    let language = get(route.url, '0.path', locale.language);
    const path = route.url.join('/').replace(new RegExp(`\\/${tridionPublication}\\/?`), '/');
    const publication = get(route, 'params.publication', tridionPublication);
    const slug = get(route, 'data.slug', '');
    const interest = get(route, 'params.interest', '');
    language = get(route, 'params.language', language);
    country = get(route, 'params.country', country);
    const prefix = compact([language, country]).join('/');
    return {
      sub_directory,
      path,
      publication,
      language,
      country,
      slug,
      interest,
      prefix
    };
  }
  getDynamic(route, siteConfig) {
    const publication = this.getPublication(route, siteConfig);
    const sub_directory = this.getSubdirectory(siteConfig);
    const {
      country,
      language
    } = this.getLocaleFromRoute(route);
    const prefix = compact([language, country]).join('/');
    // get full url but remove publication, subdirectory, and prefix as we rebuild later.
    const path = this.getCleanPathFromRoute(route, publication, prefix, sub_directory);
    const slug = get(route, 'data.slug', '');
    const interest = get(route, 'params.interest', '');
    return {
      publication,
      sub_directory,
      path,
      language,
      country,
      slug,
      interest,
      prefix,
      is_microsite: ['true', true].includes(siteConfig?.is_microsite || ''),
      site: siteConfig?.site
    };
  }
  getCleanPathFromRoute(route, publication, prefix, sub_directory) {
    const path = '/' + route.url.join('/');
    const cleanPath = this.getCleanPathFromString(path, publication, prefix, sub_directory).replace('/', '');
    return cleanPath;
  }
  getCleanPathFromString(path, publication, prefix, sub_directory) {
    const combined = [publication, prefix, sub_directory].filter(Boolean).join('|');
    const regex = new RegExp(`\\/${combined}\\/?`, 'g');
    path = decodeURIComponent(path).replace(/([^\?]+)(\?.*)/i, '$1');
    return path.replace(regex, '');
  }
  getLocaleFromRoute(route) {
    const localeSaved = this.localeService.getFromStorage();
    let {
      language,
      country
    } = this.localeService.getFromString(route.url.join('/'));
    language = get(route, 'params.language', localeSaved.language);
    country = get(route, 'params.country', localeSaved.country);
    return {
      country,
      language
    };
  }
  getSubdirectory(siteConfig) {
    return siteConfig?.tridion_pub ? get(siteConfig, 'tridion_sub_directory', '') : get(this.appDefaults, 'TRIDION_APP_DIRECTORY', '');
  }
  getPublication(route, siteConfig) {
    return siteConfig?.tridion_pub ? siteConfig?.tridion_pub : get(route, 'params.publication', this.TridionSite) || 'k2';
  }
  getUrlPrefix(language, country) {
    const locale = this.localeService.getFromStorage();
    return `/${language || locale.language}/${country || locale.country}/`;
  }
  static {
    this.ɵfac = function UrlInfoService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || UrlInfoService)(i0.ɵɵinject(i1.ActivatedRoute), i0.ɵɵinject(i2.LocaleService), i0.ɵɵinject(WINDOW), i0.ɵɵinject('TridionSite'), i0.ɵɵinject('AppDefaults'));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: UrlInfoService,
      factory: UrlInfoService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(UrlInfoService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: i1.ActivatedRoute
  }, {
    type: i2.LocaleService
  }, {
    type: undefined,
    decorators: [{
      type: Inject,
      args: [WINDOW]
    }]
  }, {
    type: undefined,
    decorators: [{
      type: Inject,
      args: ['TridionSite']
    }]
  }, {
    type: undefined,
    decorators: [{
      type: Inject,
      args: ['AppDefaults']
    }]
  }], null);
})();
class UrlInfoResolver {
  constructor(urlInfo) {
    this.urlInfo = urlInfo;
  }
  resolve(route) {
    const urlInfo = this.urlInfo.get(route);
    this.urlInfo.setUrlInfo(urlInfo);
    return urlInfo;
  }
  static {
    this.ɵfac = function UrlInfoResolver_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || UrlInfoResolver)(i0.ɵɵinject(UrlInfoService));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: UrlInfoResolver,
      factory: UrlInfoResolver.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(UrlInfoResolver, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: UrlInfoService
  }], null);
})();

/*
 * Public API Surface of url-info
 */

/**
 * Generated bundle index. Do not edit.
 */

export { UrlInfoModule, UrlInfoResolver, UrlInfoService };
